// Actions pertaining to export, print, and delete of MsgThreadListItems

import React, { Component } from 'react';
import { func, object, string } from 'prop-types';

import PrintButton from '../../../PrintButton';

import cx from 'classnames';
import s from './MessageThreadUtilities.css';


// @TODO use inline delete svg icon - get new svg that has similar output properties as the print icon from Chelsea
export default class MessageThreadUtilities extends Component {
  static propTypes = {
    msgThread: object,
    closeAlertDialog: func,
    closeConfirmDialog: func,
    className: string,
    deleteMessage: func,
    handleStateAfterDelete: func,
    openConfirmDialog: func,
    openErrorDialog: func,
    openSuccessDialog: func,
  };

  handleDeleteMessage = () => {
    this.props.deleteMessage(
      this.props.msgThread.id,
      this.successCallback,
      this.errorCallback,
    );

    // Return true so AuthLayout will close the confirmDialog
    return true;
  };

  successCallback = () =>
    this.props.openSuccessDialog({
      title: 'Message Deleted',
      content: `${this.props.msgThread.subject} was deleted successfully.`,
      okCallback: this.handleDialogClose,
    });

  errorCallback = response =>
    this.props.openErrorDialog({
      title: response.message.title,
      content: response.message.body,
      okCallback: this.handleDialogClose,
    });

  handleConfirmDelete = () =>
    this.props.openConfirmDialog({
      title: 'Delete Message',
      content: 'Are you sure you want to delete this message?',
      cancelCallback: this.props.closeConfirmDialog,
      okCallback: this.handleDeleteMessage,
    });

  handleSaveThread = () => window.open(`/api/messages/export/${this.props.msgThread.id}`);

  // Close dialog, refresh inbox
  handleDialogClose = () => {
    this.props.closeAlertDialog();
    this.props.handleStateAfterDelete();
  };

  render = () => {
    const {
      msgThread,
      className,
    } = this.props;

    if (msgThread) {
      return (
        <section id="MessageThreadUtilities" className={cx(s.component, className)}>
          <nav className={s.container}>
            <PrintButton id="message_thread_print" />
            <section className={s.flexContainer}>
              <nav className={s.iconButtonContainer}>
                <button
                  download={msgThread.subject}
                  ref="exportThread"
                  onClick={this.handleSaveThread}
                  name="save"
                  className={cx(s.iconButton, s.save)}
                >
                  Save
                </button>
              </nav>
            </section>
            <section className={s.flexContainer}>
              <nav className={s.iconButtonContainer}>
                <button
                  name="delete"
                  className={cx(s.iconButton, s.delete)}
                  onClick={this.handleConfirmDelete}
                >
                  Delete
                </button>
              </nav>
            </section>
          </nav>
        </section>
      );
    } else {
      return null;
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadUtilities/MessageThreadUtilities.js